import { Injectable } from '@angular/core';
import { Http, Response } from '@angular/http';
import { Storage } from '@ionic/storage';
import { Observable } from 'rxjs/Observable';

import { Globals } from '../providers/globals';
import { HttpHelper } from '../helpers/httpHelper';

import 'rxjs/add/operator/map';


@Injectable()
export class BusinessRedeemHandler {
 	url: any;
 	token: any;

	constructor(
		public http: Http,
		public globals: Globals,
        public storage: Storage,
        public httpHelper: HttpHelper
	){
	}

	redeemBond(userPurchaseId, cb){	
	  	this.url = this.globals.dataUrl + 'businessBond/userPurchaseId/' + userPurchaseId;

    	this.storage.get('loginData').then((loginData) => {
	      	this.token = loginData.access_token

		    this.http.get(
		        this.url,
		        this.httpHelper.configOptionsWithToken(loginData.access_token)
		    )
		    .map(res => res.json())
		    .subscribe(res => {
		          if(typeof cb == "function") cb(res.Data);
		    });   
    	})
  	}
}



// WEBPACK FOOTER //
// ./src/providers/business-redeem-handler.ts